<template>
  <div>
    <el-dialog
      v-model="dialogStatus"
      :close-on-click-modal="false"
      title="创意审核"
      @close="close"
      width="30%"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="rules"
      >
       <el-form-item prop="creativeStatus">
           <el-radio-group v-model="form.creativeStatus">
          <el-radio :label="1">通过</el-radio>
          <el-radio :label="2">拒绝</el-radio>
          <el-radio :label="3">禁用</el-radio>
        </el-radio-group>
       </el-form-item>
        <el-form-item prop="creativeDescribe">
        <el-input v-model="form.creativeDescribe" placeholder="请输入原因" type="textarea" :rows="4"></el-input>
       </el-form-item>
        <el-form-item>
         <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
       </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
 upCreativeAudit
} from "@/api/manage/creative/creative";
export default {
  data() {
    return {
      form: {
        creativeId:undefined,
        creativeDescribe: undefined,
        creativeStatus: undefined,
      },
      rules: {
        creativeStatus: [{ required: true, trigger: "blur" }],
        creativeDescribe: [{ required: false, trigger: "blur" }]
      },
      dialogStatus: false,
    };
  },
  methods: {
    show(data) {
        this.form.creativeId=data.creativeId;
      this.form.creativeDescribe = data.creativeDescribe;
      this.form.creativeStatus = data.creativeStatus;
      this.dialogStatus = true;
    },
    close() {
      this.dialogStatus = false;
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
            upCreativeAudit(this.form).then((res)=>{
                if(res.code==200){
                    this.$emit("submit")
                    this.close()
                }
            })
        } else {
          alert("审核失败");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>